import {
  pgTable,
  serial,
  text,
  timestamp,
  varchar,
  integer,
} from 'drizzle-orm/pg-core';

export const usersTable = pgTable('users_table', {
  id: serial('id').primaryKey(),
  name: text('name').notNull(),
  email: text('email').notNull().unique(),
  googleId: varchar('google_id', { length: 255 }).unique(),
  appleId: varchar('apple_id', { length: 255 }).unique(),
  profilePicture: text('profile_picture'),
  accessToken: text('access_token'),
  refreshToken: text('refresh_token'),
  tokenExpiresAt: timestamp('token_expires_at'),
  utmSource: text('utm_source'),
  createdAt: timestamp('created_at').notNull().defaultNow(),
  updatedAt: timestamp('updated_at')
    .notNull()
    .$onUpdate(() => new Date()),
});

export type InsertUser = typeof usersTable.$inferInsert & {
  googleId?: string;
  appleId?: string;
  accessToken: string;
  profilePicture?: string;
  utmSource?: string;
};
export type UserType = typeof usersTable.$inferSelect;

export const paymentsTable = pgTable('payments_table', {
  id: serial('id').primaryKey(),
  userId: integer('user_id')
    .notNull()
    .references(() => usersTable.id),
  itemId: varchar('item_id', { length: 255 }), // Lemon Squeezy subscription id or lifetime order id
  createdAt: timestamp('created_at').notNull().defaultNow(),
  updatedAt: timestamp('updated_at')
    .notNull()
    .$onUpdate(() => new Date()),
});

export type PaymentType = typeof paymentsTable.$inferSelect;

export type SelectPayment = typeof paymentsTable.$inferSelect;

export const patreonInfoTable = pgTable('patreon_info_table', {
  id: serial('id').primaryKey(),
  userId: integer('user_id')
    .notNull()
    .references(() => usersTable.id)
    .unique(),
  patreonId: varchar('patreon_id', { length: 255 }),
  patreonEmail: text('patreon_email'),
});

export const githubInfoTable = pgTable('github_info_table', {
  id: serial('id').primaryKey(),
  userId: integer('user_id')
    .notNull()
    .references(() => usersTable.id)
    .unique(),
  githubId: varchar('github_id', { length: 255 }).unique(),
  accessToken: text('access_token'),
  githubUsername: text('github_username'),
});

export type InsertPatreonInfo = typeof patreonInfoTable.$inferInsert;
export type SelectPatreonInfo = typeof patreonInfoTable.$inferSelect;

export const activePatronsTable = pgTable('active_patrons_table', {
  id: serial('id').primaryKey(),
  patreonId: varchar('patreon_id', { length: 255 }).notNull().unique(),
  name: text('name').notNull(),
});

export type InsertActivePatron = typeof activePatronsTable.$inferInsert;
export type SelectActivePatron = typeof activePatronsTable.$inferSelect;
